import { Formik, Form, FieldArray } from "formik";
import FormWrapper from "../../_local/components/FormWrapper/index";
import ResetAndSubmit from "../../_local/components/ResetAndSubmit/index";
import * as Yup from "yup";
import OccasionCard from "../../_local/components/NewCards/OccasionCard";
import NotificationCard from "../../_local/components/NewCards/NotificationCard";

const validationSchema = Yup.object({
    notification: Yup.array()
        .test(
            "at-least-one-selected",
            "At least one notification must be selected",
            (value) => value && value.some((item) => item.checked)
        )
});

const notificationsList = [
    { title: "Admissions", description: "Notify parents and students about enrollment openings, deadlines, and procedures to boost applications.", checked: true },
    { title: "Examinations/results", description: "Share exam schedules, important updates, and results to keep students informed and prepared.", checked: true },
    { title: "Announcements", description: "Communicate key updates, events, and institutional news to enhance engagement.", checked: true },
    { title: "Holidays", description: "Keep everyone updated on school closures and holiday schedules for better planning.", checked: true }
];


const Notifications = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {
    // const { globalData } = useContext(AppContext);

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("notification")) || [];
        return savedData.length ? savedData : notificationsList
    };

    return <Formik
        initialValues={{ filter: "", searchTerm: "", notification: loadInitialData() }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
            console.log("values.notification ", values.notification)
            sessionStorage.setItem("notification", JSON.stringify(values.notification));
            handleNavigate();
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => {

            const handleCheckboxChange = (index) => {
                setFieldValue(
                    `notification[${index}].checked`,
                    !values.notification[index].checked
                );
            };

            return <FormWrapper
                title={"Stay Updated, Engaged and Grow"}
                description={"Get updates on admissions, exams, results and holidays. Improve engagement, attract parents, and boost enrollments for higher revenue."}
                childern={<Form onSubmit={handleSubmit}>
                    <div className="rounded-2xl my-1">
                        <FieldArray name="notification">
                            {({ push, remove, form }) => (
                                <div className="grid grid-cols-4 gap-4">
                                    {values?.notification.map((option, index) => <NotificationCard key={"asdasdasdasdasdasdasddNotificationCard" + index} element={option} name={`notification[${index}].checked`} onChange={() => handleCheckboxChange(index)} />)}
                                </div>
                            )}
                        </FieldArray>
                    </div>
                    {!disableForm && <ResetAndSubmit
                        submitToolTip={"At least one notification must be selected."}
                        isError={Boolean(errors?.notification)}
                        resetForm={() => {
                            resetForm();
                            resetFormData();
                        }}
                    />}
                </Form>}
            />
        }}
    </Formik>
};

export default Notifications;
